import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Collapse from '@material-ui/core/Collapse';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { API, Storage, Auth } from 'aws-amplify';
import { FaFileDownload } from 'react-icons/fa';

import DropDown from "../FormComponents/DropDown"
import Image1 from './SCICHEMTrialUI/O3_MaxDailyConcPlot.png';
import Image2 from './SCICHEMTrialUI/O3_MaxDailyConcPlot_near.png';
import Image3 from './SCICHEMTrialUI/O3_tseries_Max.png';

import { styles } from './util'

class SCICHEMResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            requestId: "Regional O3 2019-11-08",

        };
        this.handleInputChange = this.handleInputChange.bind(this);

        // Avoid setting the state after the component was unmounted
        // https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
        this._isMounted = false;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate() {
    }

    showJobInfo() {
        return (
            <div style={{width: '50%', float: 'left'}}>
                <DropDown
                    title='Select Job to View: '
                    name='requestId'
                    value={this.state.requestId}
                    dropdownOptions={
                        [{
                            value: "Regional O3 2019-11-08",
                            label: "Regional O3 2019-11-08",
                        }]
                    }
                    tooltip={[<div key='runOption0'>Project description from the UI Submit page.</div>]}
                />

                <h3> Job Status:  </h3> <p style={{'marginLeft': '20px'}}> SUCCEEDED </p>
                <h3> Job ID:      </h3> <p style={{'marginLeft': '20px'}}> a716895c384f4326a4a6b0d1eaf28b26 </p>
                {this.showRequestBody()}
            </div>
        )
    }

    showRequestBody() {
            return (
                <div>
                    <Button
                        onClick={() => {this.setState({openRequestBodyTable: !this.state.openRequestBodyTable})}}
                        style={{width: '90%'}}
                        variant='outlined'
                    > Request Body </Button>

                <Collapse in={this.state.openRequestBodyTable} timeout="auto" unmountOnExit>
                        <Table style={{width: '90%'}} >
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='thin-column' > Variable </TableCell>
                                        <TableCell className='thick-column' > Value </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='thin-column' > Description </TableCell>
                                        <TableCell className='thick-column' > "Regional O3 2019-11-08" </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='thin-column' > USRLAT </TableCell>
                                        <TableCell className='thick-column' > "39.6" </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='thin-column' > USRLON </TableCell>
                                        <TableCell className='thick-column' > "-98.0" </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='thin-column' > MMIF_CHECK </TableCell>
                                        <TableCell className='thick-column' > "true" </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='thin-column' > DOMAIN_EW</TableCell>
                                        <TableCell className='thick-column' > "100" </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='thin-column' > DOMAIN_NS </TableCell>
                                        <TableCell className='thick-column' > "100" </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='thin-column' > **Other variables will be provided in the full system. </TableCell>

                                    </TableRow>
                                </TableHead>
                        </Table>
                    </Collapse>
                </div>
        )}

    render() {
        return (
            <div >
                <h1> Job Results </h1>
                {this.showJobInfo()}
                <div style={{width:'50%', float: 'right'}}>
                    <div>
                        <h3>Info:</h3>
                        <div>Maximum concentration of O3 is 0.981 ppb 59.33 km from your facility.</div>
                        <div>Maximum Design plume concentration of O3 is 0.643 ppb 60.83 km from your facility.</div>
                        <div>Maximum Design cumu concentration of O3 is 63.643 ppb 60.83 km from your facility.</div>
                        <div>--------</div>
                        <div style={{color: 'blue'}}> <u>DOWNLOAD RESULTS </u><FaFileDownload /> </div>
                        {this.state.resultTarFile && this.showResultTar()}
                    </div>
                    <img style={{textAlign:'right', height:'500px'}} src={Image1} alt=""/>
                    <img style={{textAlign:'right', height:'500px'}} src={Image2} alt=""/>
                    <img style={{textAlign:'right', height:'500px'}} src={Image3} alt=""/>
                </div>
            </div>
        )
    }
}

SCICHEMResults.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SCICHEMResults);
